import { bookingPassengerLib } from './lib';

export {
  PassengerInfoButton,
  SelectPassengerButton,
  PassengerCard,
} from './ui';

export const bookingPassengerEntity = { lib: bookingPassengerLib };
